import i18n from "@i18n";
import { Popconfirm, PopconfirmProps } from "antd";
import { FC } from "react";

export type IncPopconfirmProps = PopconfirmProps;

export const IncPopconfirm: FC<IncPopconfirmProps> = (props) => (
    <Popconfirm
        {...props}
        okText={i18n.t("common:yes")}
        cancelText={i18n.t("common:no")}
    />
);
